/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style16 = require("antd/lib/icon/style");

var _icon = require("antd/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _style17 = require("antd/lib/time-picker/style");

var _timePicker = require("antd/lib/time-picker");

var _timePicker2 = _interopRequireDefault(_timePicker);

var _style18 = require("antd/lib/select/style");

var _select = require("antd/lib/select");

var _select2 = _interopRequireDefault(_select);

var _style19 = require("antd/lib/table/style");

var _table = require("antd/lib/table");

var _table2 = _interopRequireDefault(_table);

var _style20 = require("antd/lib/date-picker/style");

var _datePicker = require("antd/lib/date-picker");

var _datePicker2 = _interopRequireDefault(_datePicker);

var _style21 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style22 = require("antd/lib/col/style");

var _col = require("antd/lib/col");

var _col2 = _interopRequireDefault(_col);

var _style23 = require("antd/lib/row/style");

var _row = require("antd/lib/row");

var _row2 = _interopRequireDefault(_row);

var _style24 = require("antd/lib/tooltip/style");

var _tooltip = require("antd/lib/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getOwnPropertyNames = require("babel-runtime/core-js/object/get-own-property-names");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _style25 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _style26 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style27 = require("antd/lib/checkbox/style");

var _checkbox = require("antd/lib/checkbox");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _style28 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style29 = require("antd/lib/radio/style");

var _radio = require("antd/lib/radio");

var _radio2 = _interopRequireDefault(_radio);

var _style30 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _immutable = require("immutable");

var _interValidate = require("util/interValidate");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactFreeScrollbar = require("react-free-scrollbar");

var _reactFreeScrollbar2 = _interopRequireDefault(_reactFreeScrollbar);

var _tpl = require("tpl");

var _tpl2 = _interopRequireDefault(_tpl);

var _comps = require("comps");

var _tool = require("util/tool");

var _config = require("util/config");

var _premissionAuth = require("util/premissionAuth");

require("./index.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var TextArea = _input2.default.TextArea;

var CheckboxGroup = _checkbox2.default.Group;

var _ref = (0, _jsx3.default)("li", {});

var _ref2 = (0, _jsx3.default)("span", {}, void 0, "\uFF1B");

var _ref3 = (0, _jsx3.default)("a", {
  href: "javascript:;"
}, void 0, "\u7F16\u8F91");

var _ref4 = (0, _jsx3.default)("a", {
  href: "javascript:;"
}, void 0, "\u5220\u9664");

var _ref5 = (0, _jsx3.default)(RadioButton, {
  value: "3"
}, void 0, "\u6309\u6E20\u9053\u5347\u7EA7");

var _ref6 = (0, _jsx3.default)(RadioButton, {
  value: "4"
}, void 0, "\u81EA\u52A8\u5347\u7EA7");

var _ref7 = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u8BF7\u9009\u62E9\u5347\u7EA7\u5305",
  type: "hidden",
  disabled: true
});

var _ref8 = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u8BF7\u8F93\u66F4\u65B0\u8981\u70B9"
});

var _ref9 = (0, _jsx3.default)(_button2.default, {
  type: "primary",
  htmlType: "submit"
}, void 0, "\u786E\u5B9A");

var _ref10 = (0, _jsx3.default)("div", {
  className: "tit"
}, void 0, "\u81EA\u52A8\u5347\u7EA7\u4EFB\u52A1\u5217\u8868");

var _ref11 = (0, _jsx3.default)(_icon2.default, {
  type: "plus"
});

var _ref12 = (0, _jsx3.default)(_icon2.default, {
  type: "plus"
});

var _ref13 = (0, _jsx3.default)("span", {}, void 0, "\u90E8\u4EF6\u7C7B\u578B\uFF1A");

var _ref14 = (0, _jsx3.default)(Option, {
  value: 10
}, void 0, "\u4E3B\u63A7\u677F");

var _ref15 = (0, _jsx3.default)(Option, {
  value: 11
}, void 0, "\u5145\u7535\u677F");

var _ref16 = (0, _jsx3.default)(Option, {
  value: 0
}, void 0, "VCU");

var _ref17 = (0, _jsx3.default)(Option, {
  value: 1
}, void 0, "BMS");

var _ref18 = (0, _jsx3.default)(Option, {
  value: 2
}, void 0, "MCCU");

var _ref19 = (0, _jsx3.default)(Option, {
  value: 3
}, void 0, "ICM");

var _ref20 = (0, _jsx3.default)("span", {}, void 0, "\u6761\u4EF6\uFF1A");

var _ref21 = (0, _jsx3.default)(Option, {
  value: 1
}, void 0, "\uFF1E");

var _ref22 = (0, _jsx3.default)(Option, {
  value: 2
}, void 0, "\uFF1E=");

var _ref23 = (0, _jsx3.default)(Option, {
  value: 3
}, void 0, "\uFF1C");

var _ref24 = (0, _jsx3.default)(Option, {
  value: 4
}, void 0, "\uFF1C=");

var _ref25 = (0, _jsx3.default)(Option, {
  value: 5
}, void 0, "=");

var _ref26 = (0, _jsx3.default)(Option, {
  value: 6
}, void 0, "\u2260");

var _ref27 = (0, _jsx3.default)("span", {}, void 0, "\u7248\u672C\uFF1A");

var _ref28 = (0, _jsx3.default)(_col2.default, {
  className: "all-name",
  span: 3
}, void 0, "\u72B6\u6001:");

var _ref29 = (0, _jsx3.default)(_radio2.default, {
  value: 0
}, void 0, "\u8FD0\u884C");

var _ref30 = (0, _jsx3.default)(_radio2.default, {
  value: 1
}, void 0, "\u5173\u95ED");

var _ref31 = (0, _jsx3.default)("div", {
  className: "cus-tips"
}, void 0, (0, _jsx3.default)("p", {
  className: "ico"
}, void 0, (0, _jsx3.default)(_icon2.default, {
  type: "check-circle-o"
})), (0, _jsx3.default)("h3", {}, void 0, "\u4E0A\u4F20\u9644\u4EF6\u6210\u529F\uFF01"), (0, _jsx3.default)("p", {}, void 0, "\u5347\u7EA7\u72B6\u6001\u8BF7\u7A0D\u5019\u67E5\u770BOTA\u5347\u7EA7\u5386\u53F2\u8BB0\u5F55\u8868"));

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.handleOk = function (e) {
      // console.log(e);
      var _this$state = _this.state,
          ruleVal = _this$state.ruleVal,
          taskVal = _this$state.taskVal,
          updateVal = _this$state.updateVal,
          timeVal = _this$state.timeVal,
          radioVal = _this$state.radioVal,
          taskIds = _this$state.taskIds;

      if (!taskVal) {
        _message2.default.warning('请输入任务名！');
        return;
      } else if (!updateVal) {
        _message2.default.warning('请选择升级包！');
        return;
      } else if (!timeVal) {
        _message2.default.warning('请选择每日执行时间！');
        return;
      }
      if (_this.state.typeNum === 1) {
        var param = {
          taskRequest: {
            productId: _this.props.params.id,
            taskName: taskVal,
            versionId: updateVal,
            // pushTime: timeVal.split(":")[0],
            pushTime: Number(timeVal),
            status: radioVal,
            creator: _this.state.userN
          },
          ruleRequestList: ruleVal
        };
        (0, _tool.http)(_config.apiJson.insertAutoUpgradeTask, param).then(function (res) {
          if (res === true) {
            _message2.default.success('新建成功！');
            _this.setState({
              visible2: false
            });
            _this.getRuleList();
          }
        });
      } else {
        var data = ruleVal.map(function (item) {
          return item.taskId ? {
            id: item.id,
            componentType: item.componentType,
            operator: item.operator,
            partFirmwareVersion: item.partFirmwareVersion
          } : {
            componentType: item.componentType,
            operator: item.operator,
            partFirmwareVersion: item.partFirmwareVersion
          };
        });
        var _param = {
          taskRequest: {
            id: taskIds,
            productId: _this.props.params.id,
            taskName: taskVal,
            versionId: updateVal,
            // pushTime: timeVal.split(":")[0],
            pushTime: Number(timeVal),
            status: radioVal,
            lastModifier: _this.state.userN
          },
          ruleRequestList: data
        };
        (0, _tool.http)(_config.apiJson.updateAutoUpgradeTask, _param).then(function (res) {
          if (res === true) {
            _message2.default.success('更新成功！');
            _this.setState({
              visible2: false
            });
            _this.getRuleList();
          }
        });
      }
    };

    _this.handleCancel = function (e) {
      // console.log(e);
      _this.setState({
        visible2: false
      });
    };

    console.log(props);
    _this.state = {
      productTemplate: null,
      packageId: "",
      adminList: ['15918823513', '13714634167', '15919809716', '13088885407', 'device'],
      adminListName: ['林培俊', '王江', '韩宪伟', '陈其彬', 'device', '董帅康'],
      pushTime: "",
      fileList: [],
      baseInfo: {},
      range: 2,
      visible: false,
      visible2: false,
      footer: false,
      packageList: [],
      packageInfo: {
        packageName: "",
        id: ""
      },
      isShowList: "none",
      isShowPackageInfo: "none",
      deviceList: [],
      allChoosed: false,
      serialNumberObj: [],
      reomveSerialNumberObj: [],
      serialNumberStr: "",
      selectedRowKeys: [],
      areaOptions: [],
      defaultCheckedList: [],
      checkVIN: false,
      ruleVal: [],
      taskVal: '',
      updateVal: '',
      timeVal: '',
      radioVal: 0,
      params: {
        page: 1,
        rows: 10,
        productId: _this.props.params.id
      },
      updateList: [],
      total: 0,
      typeNum: null,
      taskIds: null,
      updateName: '',
      userN: window.localStorage.getItem("userName"),
      deviceType: null
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var params = this.props.params;

      var options = void 0;
      options = { productId: params.id };

      if (params.rid) {
        var deviceOptions = {
          recordId: params.rid,
          deviceUpgradeStatus: 4
        };
        (0, _tool.http)(_config.apiJson.getProductUpgradeDetail, deviceOptions).then(function (res) {
          var serialNumberList = res.deviceList;
          var serialNumberStr = _this2.listToStr(serialNumberList);
          _this2.setState({
            serialNumberStr: serialNumberStr,
            range: 2
          }, function () {
            _this2.props.form.setFieldsValue({
              serialNumbers: _this2.state.serialNumberStr
            });
            //this.props.form.setFieldsValue({upgradeRange: 2})
            document.getElementById("text").value = _this2.state.serialNumberStr;
          });
        });
      }

      //this.getDeviceSimpleList()
    }
  }, {
    key: "getProductTemplate",
    value: function getProductTemplate() {
      var _this3 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this3.setState({
          productTemplate: res.productTemplate,
          deviceType: res.accessDeviceType
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // let _this = this
      this.getProductTemplate();
      this.queryDeviceSalesAreas();
      // this.clickChange()
    }
  }, {
    key: "queryDeviceSalesAreas",
    value: function queryDeviceSalesAreas() {
      var _this4 = this;

      (0, _tool.http)(_config.apiJson.getChannelInfoListByProductId, {
        productId: this.props.params.id
      }).then(function (res) {
        _this4.setState({
          areaOptions: res.map(function (mp) {
            return (0, _extends3.default)({}, mp, {
              label: mp.channelName,
              value: mp.channelCode
            });
          })
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this5 = this;

      e.preventDefault();
      this.props.form.validateFields(function (err, values) {
        if (!err) {
          if (values.upgradeRange == 2 && _this5.state.checkVIN == false) {
            _message2.default.warning("请点击“检测”进行VIN校验");
            return;
          }
          var upgradeDeviceIdsForm = void 0;
          if (values.upgradeRange == 2) {
            upgradeDeviceIdsForm = values["serialNumbers"].split(/[\n]/);
            upgradeDeviceIdsForm.forEach(function (item, index) {
              if (!item) {
                upgradeDeviceIdsForm.splice(index, 1);
              }
            });
          }
          var pushTime = _this5.state.pushTime;
          var params = _this5.props.params;
          //delete (values.file)

          var options = (0, _assign2.default)(values, {
            pushTime: pushTime,
            productId: params.id,
            serialNumbers: upgradeDeviceIdsForm || "",
            upgradeMode: 2
          });
          (0, _tool.http)(_config.apiJson.insertBaseUpgrade, options).then(function (res) {
            if (res) {
              _message2.default.success("\u5347\u7EA7\u6210\u529F");
              _this5.setState({
                visible: true
              });
              setTimeout(function () {
                _this5.setState({
                  visible: false
                });
                _this5.props.router.push({
                  pathname: "/remote/" + params.id
                });
              }, 3000);
            }
          }).catch(function (res) {
            _message2.default.warn(res.errmsg);
          });
        }
      });
    }
  }, {
    key: "cancleClick",
    value: function cancleClick(e) {
      this.props.router.push({ pathname: "/" });
    }
  }, {
    key: "onChange",
    value: function onChange(info) {
      var fileList = this.state.fileList;

      var res = info.file.response;
      if (!fileList.length) {
        this.setState({
          fileList: info.fileList
        });
      }

      if (res) {
        if (res.errcode === "100") {
          this.setState({ packageId: res.data[0] });
          _message2.default.success(info.file.name + " \u6587\u4EF6\u4E0A\u4F20\u6210\u529F");
        } else {
          this.setState({
            fileList: []
          });
          _message2.default.error(info.file.name + "\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25");
        }
      }
    }
  }, {
    key: "onRemove",
    value: function onRemove(file) {
      var status = file.status;
      status === "removed" && this.setState({
        fileList: [],
        packageId: ""
      });
    }
  }, {
    key: "rangeChange",
    value: function rangeChange(e) {
      var value = e.target.value;

      // if (value == 1) {
      //   Modal.warning({
      //     title: '谨慎操作',
      //     content: '注意选择此项会造成全量升级设备?'
      //   })
      // }
      if (value == 4) {
        this.getRuleList();
      }
      this.setState({
        range: value
      });
    }
  }, {
    key: "compare",
    value: function compare(property) {
      return function (a, b) {
        var value1 = new Date(a[property]).getTime();
        var value2 = new Date(b[property]).getTime();
        return value2 - value1;
      };
    }
  }, {
    key: "getRuleList",
    value: function getRuleList() {
      var _this6 = this;

      (0, _tool.http)(_config.apiJson.getAutoUpgradeTaskAndRuleList, this.state.params).then(function (res) {
        _this6.setState({
          updateList: res.rows.sort(_this6.compare('createTime')),
          total: res.total
        });
      });
    }
  }, {
    key: "dataPickerChange",
    value: function dataPickerChange(value, dateString) {
      this.setState({
        pushTime: dateString
      });
    }
  }, {
    key: "onOk",
    value: function onOk(value) {}
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "showPackList",
    value: function showPackList(val) {
      var _this7 = this;

      var params = this.props.params;

      var productId = params.id;
      this.setState({
        isShowPackageInfo: "none"
      });
      (0, _tool.http)(_config.apiJson.getVersionList, { productId: productId }).then(function (res) {
        if (res.length > 0) {
          if (val === 1) {
            _this7.setState({
              packageList: res
            });
          } else {
            _this7.setState({
              packageList: res,
              isShowList: "block"
            });
          }
        } else {
          _message2.default.warning("暂无升级包，请通过升级包管理上传升级包！");
        }
      });
    }
  }, {
    key: "handelError",
    value: function handelError(title, content) {
      var opt = content.map(function (d) {
        return (0, _jsx3.default)("p", {}, d.key, "\u5E8F\u53F7", d.key, ": \u6DFB\u52A0\u6709\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u683C\u5F0F");
      });
      _modal2.default.error({
        title: title,
        content: (0, _jsx3.default)("div", {}, void 0, opt)
      });
    }
  }, {
    key: "checkingVinCode",
    value: function checkingVinCode(deviceIdList) {
      return new _promise2.default(function (resolve, reject) {
        (0, _tool.http)(_config.apiJson.checkingVinCode, "deviceIdList=" + deviceIdList, "POST", true).then(function (res) {
          resolve(res);
        });
      });
    }
  }, {
    key: "checkSerial",
    value: function checkSerial() {
      var _this8 = this;

      var productTemplate = this.state.productTemplate;

      var serialNumberStr = this.props.form.getFieldValue("serialNumbers");
      if (serialNumberStr) {
        var serialNumberList = serialNumberStr.split(/[\n]/);
        var serialNumberObj = [];
        var errorSerialNumberObj = [];
        var tmpStr = "";
        serialNumberList.length > 0 ? serialNumberList.map(function (item, key) {
          var tmp = {
            key: key + 1,
            serialNumber: item
          };
          // && vinValidate(item)
          // && vinValidate(item,productTemplate)
          if (item) {
            serialNumberObj.push(tmp);
            if (key + 1 == serialNumberList.length) {
              tmpStr += item;
            } else {
              tmpStr += item + "\n";
            }
          } else {
            errorSerialNumberObj.push(tmp);
          }
        }) : null;
        if (errorSerialNumberObj.length > 0) {
          this.handelError("格式错误", errorSerialNumberObj);
          return;
        }
        // this.checkingVinCode(serialNumberList).then(res => {
        //   if (res.length > 0) {
        //     Modal.error({
        //       title: "以下vim已注册过，请删除后重新提交",
        //       content: <div>{res.join(",")}</div>
        //     });
        //     return;
        //   }

        // });

        var temp = [];
        for (var i = 0; i < serialNumberObj.length; i++) {
          if (temp.indexOf(serialNumberObj[i].serialNumber) == -1) {
            temp.push(serialNumberObj[i].serialNumber);
          } else {
            console.log(1);
            _message2.default.error('请不要填写重复的VIN码');
            return false;
          }
        }
        this.setState({
          serialNumberObj: serialNumberObj,
          serialNumberStr: tmpStr,
          checkVIN: true
        }, function () {
          _this8.props.form.setFieldsValue({
            serialNumbers: _this8.state.serialNumberStr
          });
          document.getElementById("text").value = _this8.state.serialNumberStr;
        });
      } else {
        _message2.default.warning(productTemplate === 2 ? "请输入设备ID，一行一个" : "请输入车辆编码，一行一个");
      }
    }
  }, {
    key: "hidePackList",
    value: function hidePackList() {
      this.setState({
        isShowList: "none"
      });
    }
  }, {
    key: "choosePackage",
    value: function choosePackage(packageInfo) {
      var _this9 = this;

      this.setState({
        packageInfo: packageInfo,
        isShowPackageInfo: "block"
      }, function () {
        _this9.props.form.setFieldsValue({
          versionId: _this9.state.packageInfo.id
        });
      });

      this.hidePackList();
    }
  }, {
    key: "listToStr",
    value: function listToStr(list) {
      var str = "";
      list.map(function (item) {
        if (str) {
          str = str + "\n" + item;
        } else {
          str = item;
        }
      });
      return str;
    }
  }, {
    key: "onChangeCheckedList",
    value: function onChangeCheckedList(checkedValues) {
      var _this10 = this;

      this.setState({
        defaultCheckedList: checkedValues
      }, function () {
        _this10.props.form.setFieldsValue({
          channelCodes: _this10.state.defaultCheckedList
        });
      });
    }
  }, {
    key: "removeSerialObj",
    value: function removeSerialObj(record) {
      var _this11 = this;

      Array.prototype.indexOf = function (val) {
        function isEqual(a, b) {
          //如果a和b本来就全等
          if (a === b) {
            //判断是否为0和-0
            return a !== 0 || 1 / a === 1 / b;
          }
          //判断是否为null和undefined
          if (a == null || b == null) {
            return a === b;
          }
          //接下来判断a和b的数据类型
          var classNameA = toString.call(a),
              classNameB = toString.call(b);
          //如果数据类型不相等，则返回false
          if (classNameA !== classNameB) {
            return false;
          }
          //如果数据类型相等，再根据不同数据类型分别判断
          switch (classNameA) {
            case "[object RegExp]":
            case "[object String]":
              //进行字符串转换比较
              return "" + a === "" + b;
            case "[object Number]":
              //进行数字转换比较,判断是否为NaN
              if (+a !== +a) {
                return +b !== +b;
              }
              //判断是否为0或-0
              return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case "[object Date]":
            case "[object Boolean]":
              return +a === +b;
          }
          //如果是对象类型
          if (classNameA == "[object Object]") {
            //获取a和b的属性长度
            var propsA = (0, _getOwnPropertyNames2.default)(a),
                propsB = (0, _getOwnPropertyNames2.default)(b);
            if (propsA.length != propsB.length) {
              return false;
            }
            for (var i = 0; i < propsA.length; i++) {
              var propName = propsA[i];
              //如果对应属性对应值不相等，则返回false
              if (a[propName] !== b[propName]) {
                return false;
              }
            }
            return true;
          }
          //如果是数组类型
          if (classNameA == "[object Array]") {
            if (a.toString() == b.toString()) {
              return true;
            }
            return false;
          }
        }
        for (var i = 0; i < this.length; i++) {
          if (isEqual(this[i], val)) return i;
        }
        return -1;
      };
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      var serialNumberObj = this.state.serialNumberObj;

      serialNumberObj.remove(record);
      var serialNumberStr = "";
      serialNumberObj.map(function (item, index) {
        serialNumberStr += item.serialNumber + "\n";
      });
      this.setState({
        serialNumberObj: serialNumberObj,
        serialNumberStr: serialNumberStr
      }, function () {
        _this11.props.form.setFieldsValue({
          serialNumbers: _this11.state.serialNumberStr
        });
        document.getElementById("text").value = _this11.state.serialNumberStr;
      });
    }
  }, {
    key: "removeSerialObjs",
    value: function removeSerialObjs() {
      var _this12 = this;

      var reomveSerialNumberObj = this.state.reomveSerialNumberObj;

      if (reomveSerialNumberObj.length > 0) {
        reomveSerialNumberObj.map(function (item, index) {
          _this12.removeSerialObj(item);
        });
      } else {
        _message2.default.warning("请选择要删除的号码！");
      }
      this.setState({
        selectedRowKeys: []
      });
    }
  }, {
    key: "showModal",
    value: function showModal() {
      this.setState({
        visible2: true,
        typeNum: 1,
        ruleVal: [],
        taskVal: '',
        updateVal: '',
        updateName: '',
        timeVal: '',
        radioVal: 0
      });
      this.showPackList(1);
    }
  }, {
    key: "clickChange",
    value: function clickChange() {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      var deviceType = this.state.deviceType;

      a.push({
        componentType: deviceType == 332 || deviceType == 331 || deviceType == 335 ? 10 : 0,
        operator: 1,
        partFirmwareVersion: null
      });
      if (a.length > 10) return;
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: "handleChangeType",
    value: function handleChangeType(i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a[i].componentType = val;
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: "handleChangeStatus",
    value: function handleChangeStatus(i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a[i].operator = val;
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: "handleChangeVal",
    value: function handleChangeVal(i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a[i].partFirmwareVersion = val.target.value;
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: "sc",
    value: function sc(i) {
      var copy = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      copy.splice(i, 1);
      this.setState({
        ruleVal: copy
      });
      // if (this.state.typeNum === 1) {
      //   copy.splice(i, 1)
      //   this.setState({
      //     ruleVal: copy
      //   })
      // } else {
      //   if(copy[i].taskId){
      //     // Modal.confirm({
      //     //   title: '提示',
      //     //   content: '此操作不可恢复！',
      //     //   okText: '确认',
      //     //   cancelText: '取消',
      //     //   onOk: () => {

      //     //   },
      //     // })
      //     http(apiJson.deleteAutoUpgradeRule,{id: copy[i].id, lastModifier: this.state.userN}).then(res => {
      //       console.log(res, '1231')
      //       if(res == true){
      //         copy.splice(i, 1)
      //         this.setState({
      //           ruleVal: copy
      //         })
      //       }else{
      //         Message.error('删除失败')
      //       }
      //     })
      //   }else{
      //     copy.splice(i, 1)
      //     this.setState({
      //       ruleVal: copy
      //     })
      //   }
      // }
    }
  }, {
    key: "taskChange",
    value: function taskChange(val) {
      this.setState({
        taskVal: val.target.value
      });
    }
  }, {
    key: "updateSelect",
    value: function updateSelect(val) {
      var _this13 = this;

      this.state.packageList.forEach(function (item) {
        if (val === item.id) {
          _this13.setState({
            updateVal: val,
            updateName: item.fileOriginName
          });
        }
      });
    }
  }, {
    key: "timeChange",
    value: function timeChange(time, timeString) {
      this.setState({
        timeVal: timeString
      });
    }
  }, {
    key: "changeRadioVal",
    value: function changeRadioVal(val) {
      this.setState({
        radioVal: val.target.value
      });
    }
  }, {
    key: "editUpdate",
    value: function editUpdate(val) {
      this.setState({
        visible2: true,
        typeNum: 2,
        ruleVal: val.rullInfoVoList,
        taskVal: val.taskName,
        updateVal: val.versionId,
        updateName: val.fileOriginName,
        // timeVal: `${val.pushTime}:00:00`,
        timeVal: "" + val.pushTime,
        radioVal: val.status,
        taskIds: val.id
      });
      this.showPackList(1);
    }
  }, {
    key: "handelChange",
    value: function handelChange() {
      this.setState({
        checkVIN: false
      });
    }
  }, {
    key: "disabledDate",
    value: function disabledDate(current) {
      // can not select days before today and today
      return current && current.valueOf() < Date.now() - 60 * 60 * 3600;
    }
  }, {
    key: "render",
    value: function render() {
      var _this14 = this;

      var colFormatLable = {
        span: 6
      };
      var colFormatText = {
        span: 17,
        offset: 1
      };
      var formItemCol = {
        labelCol: { span: 7 },
        wrapperCol: { span: 16, offset: 1 }
      };
      var _props = this.props,
          form = _props.form,
          initInfo = _props.initInfo,
          params = _props.params,
          product = _props.product;
      var _state = this.state,
          adminList = _state.adminList,
          adminListName = _state.adminListName,
          range = _state.range,
          baseInfo = _state.baseInfo,
          fileList = _state.fileList,
          packageList = _state.packageList,
          isShowList = _state.isShowList,
          isShowPackageInfo = _state.isShowPackageInfo,
          packageInfo = _state.packageInfo,
          deviceList = _state.deviceList,
          allChoosed = _state.allChoosed,
          serialNumberObj = _state.serialNumberObj,
          serialNumberStr = _state.serialNumberStr,
          defaultCheckedList = _state.defaultCheckedList,
          selectedRowKeys = _state.selectedRowKeys,
          productTemplate = _state.productTemplate,
          visible2 = _state.visible2,
          updateList = _state.updateList,
          total = _state.total,
          deviceType = _state.deviceType;
      var getFieldDecorator = form.getFieldDecorator;

      var token = window.localStorage.getItem("token");
      var role = window.localStorage.getItem("userName");
      var isAdmin2 = adminListName.includes(role);
      var ctoken = (0, _premissionAuth.getToken)();

      var headers = {
        Token: ctoken ? ctoken : token
      };

      var props = {
        name: "file",
        action: "" + _config.target + _config.apiJson.upload,
        data: {
          businessType: "DEVICE_UPGRADE_PACKAGE"
        },
        fileList: fileList,
        onRemove: this.onRemove.bind(this),
        headers: headers
      };

      var wrapClassName = "cus-tips-box";
      var closable = false;

      var packageOptions = [];
      packageList.map(function (item, key) {
        var packageInfo = {
          id: item.id,
          packageName: item.fileOriginName,
          versionCode: item.versionCode,
          versionName: item.versionName,
          packageVerifyValue: item.packageVerifyValue,
          remark: item.remark
        };
        var packageTpl = (0, _jsx3.default)("ul", {
          className: "package-li",
          onClick: _this14.choosePackage.bind(_this14, packageInfo),
          style: { position: "relative" }
        }, item.id, _ref, (0, _jsx3.default)("li", {}, void 0, (0, _jsx3.default)("p", {
          style: { lineHeight: "28px" }
        }, void 0, item.fileOriginName), (0, _jsx3.default)(_tooltip2.default, {
          placement: "top",
          title: "\u66F4\u65B0\u8981\u70B9\uFF1A" + item.remark
        }, void 0, (0, _jsx3.default)("p", {
          style: {
            width: "320px",
            lineHeight: "13px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "left",
            position: "absolute"
          }
        }, void 0, "\u66F4\u65B0\u8981\u70B9\uFF1A" + item.remark))), (0, _jsx3.default)("li", {}, void 0, item.versionCode), (0, _jsx3.default)("li", {}, void 0, item.createTime));
        packageOptions.push(packageTpl);
      });

      var uidInfo = (0, _jsx3.default)(_row2.default, {}, void 0, _react2.default.createElement(
        _col2.default,
        (0, _extends3.default)({}, colFormatLable, { className: "tr" }),
        "\u6570\u91CF\uFF1A"
      ), _react2.default.createElement(
        _col2.default,
        colFormatText,
        deviceList.length || "未知",
        "\u4E2A"
      ));

      var idInfo = (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_row2.default, {}, void 0, _react2.default.createElement(
        _col2.default,
        (0, _extends3.default)({}, colFormatLable, { className: "tr" }),
        "\u5F53\u524D\u7248\u672C\uFF1A"
      ), _react2.default.createElement(
        _col2.default,
        colFormatText,
        "v",
        baseInfo.lastUpgradeVersion || "未知"
      )), (0, _jsx3.default)(_row2.default, {}, void 0, _react2.default.createElement(
        _col2.default,
        (0, _extends3.default)({}, colFormatLable, { className: "tr" }),
        "\u4E0A\u6B21\u66F4\u65B0\u65F6\u95F4\uFF1A"
      ), _react2.default.createElement(
        _col2.default,
        colFormatText,
        baseInfo.createTime
      )));

      //设置升级区域
      var areaOptions = this.state.areaOptions;
      var paginations = {
        defaultCurrent: 1,
        current: this.state.params.page,
        total: total,
        pageSize: this.state.params.rows,
        showTotal: function showTotal(total) {
          return "\u5171\u8BA1 " + total + " \u6761";
        },
        showQuickJumper: true,
        onChange: function onChange(current) {
          _this14.state.params.page = current;
          _this14.getRuleList();
        }
      };

      var OTAcolumns = [{
        title: '任务名',
        dataIndex: 'taskName',
        key: 'taskName'
      }, {
        title: '规则描述',
        dataIndex: 'rullInfoVoList',
        render: function render(text, record) {
          var tmp = {};
          if (deviceType == 332 || deviceType == 331 || deviceType == 335) {
            tmp = {
              '10': '主控板',
              '11': '充电板'
            };
          } else {
            tmp = {
              '0': 'VCU',
              '1': 'BMS',
              '2': 'MCCU',
              '3': 'ICM'
            };
          }
          var tmp2 = {
            '1': '＞',
            '2': '＞=',
            '3': '＜',
            '4': '＜=',
            '5': '=',
            '6': '≠'
          };

          return record.rullInfoVoList.map(function (item, index) {
            return (0, _jsx3.default)("span", {}, void 0, tmp[item.componentType], tmp2[item.operator], item.partFirmwareVersion, record.rullInfoVoList.length - 1 === index ? '' : _ref2);
          });
        }
      }, {
        title: '执行次数',
        dataIndex: 'runCount',
        // key: 'runCount',
        sorter: function sorter(a, b) {
          return Number(a.runCount) - Number(b.runCount);
        }
      }, {
        title: '状态',
        dataIndex: 'status',
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {}, void 0, record.status == 0 ? '运行' : '关闭');
        }
      }, {
        title: '每日执行时间',
        dataIndex: 'pushTime',
        sorter: function sorter(a, b) {
          return Number(a.pushTime) - Number(b.pushTime);
        },
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {}, void 0, record.pushTime, ":00:00");
        }
      }, {
        title: '升级包',
        dataIndex: 'fileOriginName',
        key: 'fileOriginName'
      }, {
        title: '创建时间',
        dataIndex: 'createTime',
        sorter: function sorter(a, b) {
          return new Date(a.createTime).getTime() - new Date(b.createTime).getTime();
        }
      }, {
        title: '操作',
        dataIndex: 'operation',
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {
            onClick: _this14.editUpdate.bind(_this14, record)
          }, void 0, _ref3);
        }
      }];
      var columns = [{
        title: "序号",
        dataIndex: "key"
      }, {
        title: "号码",
        dataIndex: "serialNumber"
      }, {
        title: "操作",
        dataIndex: "operation",
        render: function render(text, record) {
          return (0, _jsx3.default)("div", {
            onClick: function onClick() {
              return _this14.removeSerialObj(record);
            }
          }, void 0, _ref4);
        }
      }];

      var rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: function onChange(selectedRowKeys, selectedRows) {
          _this14.setState({
            selectedRowKeys: selectedRowKeys,
            reomveSerialNumberObj: selectedRows
          });
        }
      };

      return (0, _jsx3.default)("div", {
        className: "remote-contain"
      }, void 0, (0, _jsx3.default)("div", {
        className: "remote-update"
      }, void 0, (0, _jsx3.default)("div", {
        className: "cover",
        style: { display: isShowList },
        onClick: this.hidePackList.bind(this)
      }), (0, _jsx3.default)("div", {
        className: "update-levelinfo"
      }, void 0, (0, _jsx3.default)("div", {
        className: "info-cont"
      }, void 0, (0, _jsx3.default)(_form2.default, {
        onSubmit: this.handleSubmit.bind(this)
      }, void 0, (0, _jsx3.default)(FormItem, {
        label: ""
      }, void 0, getFieldDecorator("upgradeRange", {
        rules: [{ required: true, message: "请选择升级范围" }],
        initialValue: "" + range
      })((0, _jsx3.default)(RadioGroup, {
        onChange: this.rangeChange.bind(this)
      }, void 0, isAdmin2 && (0, _jsx3.default)(RadioButton, {
        value: "1"
      }, void 0, productTemplate === 2 ? '全部设备' : '全部车辆'), (0, _jsx3.default)(RadioButton, {
        value: "2"
      }, void 0, productTemplate === 2 ? '指定设备序列号' : '指定VIN码'), isAdmin2 && productTemplate === 1 && _ref5, isAdmin2 && (productTemplate === 1 || deviceType == 332 || deviceType == 331 || deviceType == 335) && _ref6))), range == 2 ? _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: productTemplate === 2 ? "添加设备序列号" : "添加VIN码" }, formItemCol),
        (0, _jsx3.default)("div", {
          className: "cover-text"
        }, void 0, getFieldDecorator("serialNumbers", {
          rules: [{
            required: true,
            message: productTemplate === 2 ? "请输入设备序列号，一行一个" : "请输入车辆编码，一行一个"
          }],
          initialValue: "" + serialNumberStr
        })((0, _jsx3.default)("div", {
          className: "serial"
        }, void 0, (0, _jsx3.default)(TextArea, {
          id: "text",
          style: { height: "395px" },
          placeholder: productTemplate === 2 ? "请输入设备序列号，一行一个" : "请输入车辆编码，一行一个",
          onChange: this.handelChange.bind(this)
        }), (0, _jsx3.default)("div", {
          className: "btnlist"
        }, void 0, (0, _jsx3.default)(_button2.default, {
          onClick: this.checkSerial.bind(this)
        }, void 0, "\u68C0\u6D4B")))))
      ) : null, range == 3 ? _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u5347\u7EA7\u6E20\u9053" }, formItemCol),
        (0, _jsx3.default)("div", {
          className: "cover-text"
        }, void 0, getFieldDecorator("channelCodes", {
          // rules: [{ required: true, message: "设置升级渠道" }],
          rules: [{
            validator: function validator(rule, value, callback) {
              var s = _this14.props.form.getFieldValue("channelCodes");
              s && s.length >= 1 ? callback() : callback(true);
            },
            message: "设置升级渠道"
          }]
        })((0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(CheckboxGroup, {
          options: areaOptions,
          defaultValue: defaultCheckedList,
          onChange: this.onChangeCheckedList.bind(this)
        }))))
      ) : null, range !== '4' ? (0, _jsx3.default)("div", {}, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u9009\u62E9\u5347\u7EA7\u5305" }, formItemCol),
        (0, _jsx3.default)(_row2.default, {
          gutter: 12
        }, void 0, (0, _jsx3.default)(_col2.default, {
          span: 16
        }, void 0, (0, _jsx3.default)(_input2.default, {
          placeholder: "\u8BF7\u9009\u62E9\u5347\u7EA7\u5305",
          value: packageInfo.packageName,
          disabled: true
        })), (0, _jsx3.default)(_col2.default, {}, void 0, getFieldDecorator("versionId", {
          rules: [{ required: true, message: "请选择升级包" }],
          initialValue: "" + packageInfo.id
        })(_ref7)), (0, _jsx3.default)(_col2.default, {
          span: 8
        }, void 0, (0, _jsx3.default)("div", {
          className: "get-package"
        }, void 0, (0, _jsx3.default)(_button2.default, {
          onClick: this.showPackList.bind(this)
        }, void 0, "\u9009\u62E9\u5347\u7EA7\u5305"), (0, _jsx3.default)("div", {
          className: "package-list",
          style: { display: isShowList }
        }, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {
          style: { width: "100%", height: "100%" },
          autohide: true
        }, void 0, packageOptions)))))
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u66F4\u65B0\u8981\u70B9" }, formItemCol),
        getFieldDecorator("remark", {
          rules: [{ required: true, message: "更新要点不能为空" }]
        })(_ref8)
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u63A8\u9001\u65F6\u95F4" }, formItemCol),
        getFieldDecorator("pushTime", {
          rules: [{ required: true, message: "推送时间不能为空" }]
        })((0, _jsx3.default)(_datePicker2.default, {
          showTime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "\u8BF7\u9009\u62E9\u65F6\u95F4",
          disabledDate: this.disabledDate.bind(this),
          onChange: this.dataPickerChange.bind(this),
          onOk: this.onOk,
          className: "time"
        }))
      ), (0, _jsx3.default)(FormItem, {
        wrapperCol: { span: 24 }
      }, void 0, (0, _jsx3.default)("div", {
        className: "btn-group"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: "default",
        onClick: this.cancleClick.bind(this)
      }, void 0, "\u53D6\u6D88"), _ref9))) : null))), range == '4' ? (0, _jsx3.default)("div", {
        className: "automatic"
      }, void 0, (0, _jsx3.default)("div", {
        className: "automatic-tit"
      }, void 0, _ref10, (0, _jsx3.default)(_button2.default, {
        type: "primary",
        onClick: this.showModal.bind(this)
      }, void 0, _ref11, "\u65B0\u5EFA")), (0, _jsx3.default)(_table2.default, {
        className: "list",
        dataSource: updateList,
        pagination: paginations,
        columns: OTAcolumns
      })) : null, (0, _jsx3.default)(_modal2.default, {
        title: this.state.taskVal ? "编辑自动升级" : "新建自动升级",
        visible: visible2,
        onOk: this.handleOk.bind(this),
        onCancel: this.handleCancel.bind(this),
        width: 650,
        wrapClassName: this.state.updateName ? 'aaa' : 'modalstyle',
        mask: false
      }, void 0, (0, _jsx3.default)(_row2.default, {
        style: { marginBottom: 20 },
        className: "update-list"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        style: { lineHeight: '28px' },
        className: "all-name",
        span: 3
      }, void 0, "\u4EFB\u52A1\u540D:"), (0, _jsx3.default)(_col2.default, {
        span: 21
      }, void 0, (0, _jsx3.default)(_input2.default, {
        value: this.state.taskVal,
        placeholder: "\u5347\u7EA7\u4EFB\u52A1\u540D\u79F0",
        onChange: this.taskChange.bind(this),
        style: { width: "100%" }
      }))), (0, _jsx3.default)(_row2.default, {
        style: { marginBottom: 20 },
        className: "update-list"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        style: { lineHeight: '28px' },
        className: "all-name",
        span: 6
      }, void 0, "\u5347\u7EA7\u89C4\u5219:"), (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_button2.default, {
        type: "dashed",
        onClick: this.clickChange.bind(this),
        style: { width: "100%" }
      }, void 0, _ref12, " \u6DFB\u52A0"))), this.state.ruleVal.map(function (item, index) {
        return (0, _jsx3.default)(_row2.default, {
          style: { marginBottom: 20 },
          className: "update-list"
        }, void 0, (0, _jsx3.default)(_col2.default, {
          span: 8
        }, void 0, _ref13, deviceType == 332 || deviceType == 331 || deviceType == 335 ? (0, _jsx3.default)(_select2.default, {
          value: item.componentType,
          onChange: _this14.handleChangeType.bind(_this14, index),
          style: { width: 100 }
        }, void 0, _ref14, _ref15) : (0, _jsx3.default)(_select2.default, {
          value: item.componentType,
          onChange: _this14.handleChangeType.bind(_this14, index),
          style: { width: 100 }
        }, void 0, _ref16, _ref17, _ref18, _ref19)), (0, _jsx3.default)(_col2.default, {
          span: 7
        }, void 0, _ref20, (0, _jsx3.default)(_select2.default, {
          value: item.operator,
          onChange: _this14.handleChangeStatus.bind(_this14, index),
          style: { width: 100 }
        }, void 0, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26)), (0, _jsx3.default)(_col2.default, {
          span: 7
        }, void 0, _ref27, (0, _jsx3.default)(_input2.default, {
          value: item.partFirmwareVersion,
          onChange: _this14.handleChangeVal.bind(_this14, index),
          style: { width: 100 }
        })), (0, _jsx3.default)(_col2.default, {
          style: { lineHeight: '28px', color: '#3296FA' },
          span: 2
        }, void 0, (0, _jsx3.default)("span", {
          onClick: _this14.sc.bind(_this14, index),
          style: { cursor: 'pointer' }
        }, void 0, "\u5220\u9664")));
      }), (0, _jsx3.default)(_row2.default, {
        style: { marginBottom: 20 },
        className: "update-list"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        style: { lineHeight: '28px' },
        className: "all-name",
        span: 3
      }, void 0, "\u5347\u7EA7\u5305:"), (0, _jsx3.default)(_col2.default, {
        span: 21
      }, void 0, (0, _jsx3.default)(_select2.default, {
        placeholder: "\u8BF7\u9009\u62E9\u5347\u7EA7\u5305",
        className: "selectup",
        value: this.state.updateName || '请选择升级包',
        onChange: this.updateSelect.bind(this),
        style: { width: '100%' }
      }, void 0, packageList.map(function (item) {
        return (0, _jsx3.default)(Option, {
          value: item.id
        }, item.id, (0, _jsx3.default)(_row2.default, {}, void 0, (0, _jsx3.default)(_col2.default, {
          span: 12
        }, void 0, (0, _jsx3.default)("div", {}, void 0, item.fileOriginName), (0, _jsx3.default)("div", {}, void 0, "\u66F4\u65B0\u8981\u70B9\uFF1A", item.remark)), (0, _jsx3.default)(_col2.default, {
          span: 6,
          style: { 'text-overflow': 'ellipsis', overflow: 'hidden' }
        }, void 0, item.versionCode), (0, _jsx3.default)(_col2.default, {
          span: 6
        }, void 0, item.createTime)));
      })))), (0, _jsx3.default)(_row2.default, {
        style: { marginBottom: 20 },
        className: "update-list"
      }, void 0, (0, _jsx3.default)(_col2.default, {
        style: { lineHeight: '28px' },
        className: "all-name",
        span: 3
      }, void 0, "\u6BCF\u65E5\u6267\u884C\u65F6\u95F4:"), (0, _jsx3.default)(_col2.default, {
        span: 18
      }, void 0, (0, _jsx3.default)(_timePicker2.default, {
        value: this.state.timeVal ? (0, _moment2.default)(this.state.timeVal, 'HH') : '',
        format: 'HH',
        onChange: this.timeChange.bind(this),
        defaultOpenValue: (0, _moment2.default)('00', 'HH')
      }))), (0, _jsx3.default)(_row2.default, {
        style: { marginBottom: 20 },
        className: "update-list"
      }, void 0, _ref28, (0, _jsx3.default)(_col2.default, {
        span: 18
      }, void 0, (0, _jsx3.default)(RadioGroup, {
        onChange: this.changeRadioVal.bind(this),
        value: this.state.radioVal
      }, void 0, _ref29, _ref30)))), (0, _jsx3.default)(_modal2.default, {
        visible: this.state.visible,
        footer: this.state.footer,
        wrapClassName: wrapClassName,
        closable: closable,
        width: 252,
        onCancel: this.onCancel.bind(this)
      }, void 0, _ref31)), range == 2 && serialNumberObj.length > 0 ? (0, _jsx3.default)("div", {
        className: "device-list"
      }, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {
        style: { width: "100%", height: "100%" }
      }, void 0, (0, _jsx3.default)(_table2.default, {
        rowSelection: rowSelection,
        columns: columns,
        dataSource: serialNumberObj,
        pagination: false
      })), (0, _jsx3.default)("div", {
        className: "bun"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: function onClick() {
          return _this14.removeSerialObjs();
        }
      }, void 0, "\u6279\u91CF\u5220\u9664"))) : null);
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: "", // 应用关联使用的redux
  component: _form2.default.create()(Main), // 接收数据的组件入口
  url: ""
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/update/index.jsx
// module id = 1493
// module chunks = 0